import React, { useState } from 'react'
import RTable from 'react-table'
import Moment from 'react-moment'
import { pascal } from 'change-case'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { reduxForm, getFormValues } from 'redux-form'
import { compose, lifecycle, withState } from 'recompose'
import { Collapse, Fade, Card, CardHeader, CardContent } from '@material-ui/core'
import Approvers from './Approvers'
import DisplayField from './DisplayField'
import { ProcurementBody } from '../../../styled'
import { BottomActionsContainer } from '../styled'
import { getOptionTitle, calculateTotalAmount, getDocumentTypes, calculateVat, calculateTotalIncludeVat } from '../../helper'
import { SummaryContainer, RequestInformationContainer, GeneralInfoContainer, 
  TotalAmountContainer, ItemsContainer, BudgetContainer } from './styled'
import { costCenterColumn, wbsColumn, internalOrderColumn, itemColumns } from '../data'
import { createPr, getWorkflowApprover, validateBudget } from 'ducks/purchaseRequisition'
import { showConfirmModal, showModal, appLoading } from 'ducks/app'
import { getCategory, getSubCategory } from '../../helper'

const attributeForPrItems = (props) => {
  const valueForm = props.valueForm || {}
  const items = valueForm ? valueForm.items ? valueForm.items : [] : []
  return { 
    accountAssignmentOptions: props.accountAssignmentOptions,
    assetOptions: props.assetOptions,
    budgetTypeOptions: props.budgetTypeOptions,
    costCenterOptions: props.costCenterOptions,
    currencyOptions: props.currencyOptions,
    glAccountOptions: props.glAccountOptions,
    items, 
    unitOptions: props.unitOptions,
    materialGroupOptions: props.materialGroupOptions,
    orderOptions: props.orderOptions,
    plantOptions: props.plantOptions,
    profitCenterOptions: props.profitCenterOptions,
    purchasingGroupOptions: props.purchasingGroupOptions,
    purchasingOrgOptions: props.purchasingOrgOptions, 
    storageLocationOptions: props.storageLocationOptions,
    wbsOptions: props.wbsOptions,
    withActions: false, 
  }
}

const validateAttachments = (props) => {
  const errors = []
  const { values, attachmentType } = props
  let documentTypes = getDocumentTypes(attachmentType, values.special, values.isAdditional)

  documentTypes.forEach((dt) => {
    const code = dt.code.toLowerCase()
    if (dt.isRequire) {
      let docValue = values[code]
      if (docValue) {
        if (!docValue.length) {
          errors.push({fieldName: dt.name, message: 'Required!'})
        }
      } else {
        errors.push({fieldName: dt.name, message: 'Required!'})
      }
    }
  })

  return errors
}

const onSubmitPr = (props, onCreateFail) => {
  const { values, history, createPr, attachmentType, showConfirmModal, setFormStep, showModal, appLoading } = props

  const checkAttachments = () => {
    let missingAttachments = validateAttachments({ values, attachmentType })
    if (missingAttachments.length === 0) {
      if (values.special === false) {
        values.specialTitle = ''
        values.specialReason = ''
      }
    
      if (values.isAdditional === false) {
        values.additionalReason = ''
        values.referencePoNo = ''
        values.referenceContractNo = ''
      }
    
      createPr(values, true, history, appLoading, onCreateFail)
    } else {
      showConfirmModal(
        true, 
        { 
          header: 'Please attach document!', 
          message: <React.Fragment><ul>{missingAttachments.map(v => <li>{v.fieldName}</li>)}</ul></React.Fragment>,
          btnConfirmText: 'Go to "Attachment"',
          onClickConfirm: () => setFormStep(4),
          confirmIcon: 'arrow right'
        }
      )
    }
  }

  if (values.budgetData.internalOrder.length) {
    let missingPlan = values.budgetData.internalOrder.filter(b => b.plan === 0 || b.plan === undefined || b.plan === null)
    if (missingPlan.length !== 0) {
      showModal(true, `Can't submit`, 'Cannot submit this document. Because internal order plan is zero!')
    } else {
      checkAttachments()
    }
  } else {
    checkAttachments()
  }
}

const Summary = (props) => {
  const { createPr, history, showGeneralInfo, showItems, showBudgets, 
    attachmentType, showConfirmModal, showModal, appLoading } = props
  const values = props.valueForm ? props.valueForm : {}
  const budgetData = values.budgetData ? values.budgetData : { costCenter: [], wbs: [], internalOrder: [] }
  
  const [showReqInfo, setShowReqInfo] = useState(true)
  const [isDisableBtn, setIsDisableBtn] = useState(false)
  const currency  = (values.items && values.items.length > 0) ? values.items[0].currency : 'THB'
  
  return (
    <Collapse in timeout={0}>
      <Fade in timeout={1000}>
        <ProcurementBody>
          <SummaryContainer>
            <form>
              <Card> {/* Request Information */}
                <CardHeader 
                  title='Request Information'
                  action={
                    <div className='cardHeaderActions'>
                      <Approvers loading={props.approverLoading} approvers={props.approvers} />
                      <Button 
                        circular 
                        type='button' 
                        icon={`chevron ${showReqInfo ? 'up' : 'down'}`} 
                        onClick={() => setShowReqInfo(!showReqInfo)} 
                      />
                    </div>
                  }
                />
                <Collapse in={showReqInfo}>
                  <CardContent>
                    <RequestInformationContainer>
                      <div className='sectionRow'>
                        <DisplayField label='Title (Request for)' value={values.title} />
                      </div>
                      <div className='sectionRow'>
                        <DisplayField label='Remark' value={values.remark} />
                      </div>
                      <div className='sectionRow'>
                        <DisplayField label='Requester' value={getOptionTitle(props.memberOptions, values.requesterUser)} />
                        <DisplayField label='Company' value={getOptionTitle(props.companyOptions, values.companyCode)} />
                      </div>
                      <div className='sectionRow'>
                        <DisplayField label='Project Name' value={getOptionTitle(props.projectOptions, values.projectId)} />
                        <DisplayField label='Department' value={values.requesterDepartment} />
                      </div>
                      <div className='sectionRow'>
                        <DisplayField label='Special Approval' value={getOptionTitle(props.specialApprovalOptions, values.specialApprovalId)} />
                        <DisplayField label='Document Date' value={<Moment format='DD MMMM YYYY'>{values.documentDate}</Moment>} />
                      </div>
                    </RequestInformationContainer>
                  </CardContent>
                </Collapse>
              </Card>
              <Card> {/* General Information */}
                <CardHeader 
                  title='General Information'
                  action={
                    <div className='cardHeaderActions'>
                      <Button 
                        circular 
                        type='button' 
                        icon={`chevron ${showGeneralInfo ? 'up' : 'down'}`} 
                        onClick={() => props.setShowGeneralInfo(!showGeneralInfo)} 
                      />
                    </div>
                  }
                />
                <Collapse in={showGeneralInfo}>
                  <CardContent>
                    <GeneralInfoContainer>
                      <div className='rowFields'>
                        <DisplayField label='Priority' value={pascal(values.priority)} />
                      </div>
                      <div className='rowFields'>
                        <DisplayField label='Special' value={values.special ? 'Yes' : 'No'} />
                      </div>
                      <Collapse in={values.special} timeout={500}>
                        <div className='rowFields'>
                          <DisplayField label='Special PR Title' value={values.specialTitle} />
                        </div>
                        <div className='rowFields'>
                          <DisplayField label='Special PR Reason' value={values.specialReason} />
                        </div>
                        <div className='rowFields'>
                          <DisplayField label='Vendor' value={getOptionTitle(props.vendorOptions, values.vendorCode)} />
                        </div>
                      </Collapse>
                      <div className='rowFields'>
                        <DisplayField label='Additional' value={values.isAdditional ? 'Yes' : 'No'} />
                      </div>
                      <Collapse in={values.isAdditional} timeout={500}>
                        <div className='rowFields'>
                          <DisplayField label='Additional Reason' value={values.additionalReason} />
                        </div>
                        <div className='rowFields'>
                          <DisplayField label='Reference PO No' value={values.referencePoNo} />
                          <DisplayField label='Reference Contract No' value={values.referenceContractNo} />
                        </div>
                      </Collapse>
                      {
                        values.isRent ? 
                        <div className='rowFields'>
                          <DisplayField label='Rent (days)' value={values.rentDays} />
                        </div> : null
                      }
                      <div className='rowFields'>
                        <DisplayField label='Type' value={getOptionTitle(props.prTypeOptions, values.type)} />
                        <DisplayField label='GOA' value={getOptionTitle(props.goaItemOptions, values.goaItemCode)} />
                      </div>
                      <div className='rowFields'>
                        <DisplayField label='Is Asset' value={values.isAsset ? 'Yes' : 'No'} />
                        <DisplayField label='Is IT' value={values.isIt ? 'Yes' : 'No'} />
                      </div>
                    </GeneralInfoContainer>
                  </CardContent>
                </Collapse>
              </Card>
              <Card> {/* Items Information */}
                <CardHeader 
                  title='Items'
                  action={
                    <div className='cardHeaderActions'>
                      <Button 
                        circular 
                        type='button' 
                        icon={`chevron ${showItems ? 'up' : 'down'}`} 
                        onClick={() => props.setShowItems(!showItems)} 
                      />
                    </div>
                  }
                />
                <Collapse in={showItems}>
                  <CardContent>
                    <ItemsContainer>
                      <RTable
                        className='prItems'
                        minRows={0}
                        columns={itemColumns(attributeForPrItems(props))}
                        data={values.items || []}
                      />
                      <TotalAmountContainer>
                        <span className='labelText'>Total Amount</span>
                        {/* {calculateTotalAmount(values.items || [])} */}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {calculateTotalAmount(values.items || [])}
                          <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{` ${currency}`}</span>
                        </div>
                      </TotalAmountContainer>
                      <TotalAmountContainer>
                        <span className='labelText'>Vat {values.vatRate}%</span>
                        {/* {calculateVat(values.items || [], values.vatRate)} */}
                        <div style={{  display: 'flex', alignItems: 'center', marginRight: '0px' }}>
                          {calculateVat(values.items || [], values.vatRate)}
                          <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{` ${currency}`}</span>
                        </div>
                      </TotalAmountContainer>
                      <TotalAmountContainer>
                        <span className='labelText'>Net Amount</span>
                        {/* {calculateTotalIncludeVat(values.items || [], values.vatRate)} */}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {calculateTotalIncludeVat(values.items || [], values.vatRate)}
                          <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{` ${currency}`}</span>
                        </div>
                      </TotalAmountContainer>
                    </ItemsContainer>
                  </CardContent>
                </Collapse>
              </Card>
              { /* Budget Information */
                (budgetData.costCenter.length > 0 || 
                  budgetData.wbs.length > 0 || 
                  budgetData.internalOrder.length > 0) ?
                  <BudgetContainer>
                    <Card>
                      <CardHeader 
                        title='Budget Information'
                        action={
                          <div className='cardHeaderActions'>
                            <Button 
                              circular 
                              type='button' 
                              icon={`chevron ${showBudgets ? 'up' : 'down'}`} 
                              onClick={() => props.setShowBudgets(!showBudgets)} 
                            />
                          </div>
                        }
                      />
                      <Collapse in={showBudgets}>
                        <CardContent>
                          <div>
                            {
                              budgetData.costCenter.length > 0 ?
                              <div className='budgetTable'>
                                <span className='tableTitle'>Cost Center</span>
                                <RTable
                                  className='budgets'
                                  columns={costCenterColumn}
                                  data={budgetData.costCenter}
                                  minRows={budgetData.costCenter.length || 1}
                                  showPagination={false}
                                />
                              </div> : null
                            }
                            {
                              budgetData.wbs.length > 0 ?
                              <div className='budgetTable'>
                                <span className='tableTitle'>Work Breakdown Structure (WBS)</span>
                                <RTable
                                  className='budgets'
                                  columns={wbsColumn}
                                  data={budgetData.wbs}
                                  minRows={budgetData.wbs.length || 1}
                                  showPagination={false}
                                />
                              </div> : null
                            }
                            {
                              budgetData.internalOrder.length > 0 ?
                              <div className='budgetTable'>
                                <span className='tableTitle'>Internal Order</span>
                                <RTable
                                  className='budgets'
                                  columns={internalOrderColumn}
                                  data={budgetData.internalOrder}
                                  minRows={budgetData.internalOrder.length || 1}
                                  showPagination={false}
                                />
                              </div> : null
                            }
                          </div>
                        </CardContent>
                      </Collapse>
                    </Card>
                  </BudgetContainer> 
                  : null
              }
            </form>
            <BottomActionsContainer>
              <Button 
                type='button'
                content='Back'
                icon='arrow left' 
                labelPosition='left'
                color='red'
                onClick={() => props.setFormStep(4)} 
              />  
              <div>
                <Button 
                  type='button'
                  content='Save' 
                  icon='save' 
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => {
                    setIsDisableBtn(true)
                    if (values.special === false) {
                      values.specialTitle = ''
                      values.specialReason = ''
                      values.vendorCode = ''
                    }

                    if (values.isAdditional === false) {
                      values.additionalReason = ''
                      values.referencePoNo = ''
                      values.referenceContractNo = ''
                    }

                    createPr(values, false, history, appLoading , () =>{ setIsDisableBtn(false)})
                  }}
                  disabled={isDisableBtn}
                />
                <Button 
                  type='button'
                  content='Save & Submit' 
                  color='blue' 
                  icon='save' 
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => {
                    setIsDisableBtn(true)
                    onSubmitPr({ 
                      values, 
                      history, 
                      createPr, 
                      attachmentType, 
                      showConfirmModal,
                      showModal,
                      setFormStep: props.setFormStep,
                      appLoading
                    },
                    () => {setIsDisableBtn(false)}
                    )}
                  }
                  disabled={isDisableBtn}
                />
              </div>
            </BottomActionsContainer>
          </SummaryContainer>
        </ProcurementBody>
      </Fade>
    </Collapse>
  )
}

const mapStateToProps = (state) => {
  const valueForm = getFormValues('formCreatePR')(state) || {}

  let goaOptions = []
  if (valueForm.companyCode && state.goa.goa && state.goa.goa[valueForm.companyCode]) {
    goaOptions = state.goa.goa[valueForm.companyCode].map(goa => { 
      return { value: goa.id, text: goa.name } 
    })
  }

  let goaItemOptions = []
  if (valueForm.goaId && state.goa.goaItems && state.goa.goaItems[valueForm.goaId]) {
    goaItemOptions = state.goa.goaItems[valueForm.goaId].map(item => { 
      return { value: item.goaItemCode, text: item.goaItemName } 
    })
  }

  const memberOptions = state.member.members.map(m => ({ value: m.username, text: `${m.firstnameEn} ${m.lastnameEn}` }))
  
  let projectOptions = []
  if (valueForm.companyCode && state.goa.projects && state.goa.projects[valueForm.companyCode]) {
    projectOptions = state.goa.projects[valueForm.companyCode].map(p => { 
      return { value: p.id, text: p.projectName } 
    })

    if (state.goa.projects.other) {
      state.goa.projects.other.forEach(p => { 
        projectOptions.push({ value: p.id, text: p.projectName })
      })
    }
  }

  let specialApprovalOptions = []
  if (valueForm.projectId && state.goa.specialApprovals && state.goa.specialApprovals[valueForm.projectId]) {
    specialApprovalOptions = state.goa.specialApprovals[valueForm.projectId].map(s => { 
      return { value: s.id, text: s.name } 
    })
  }

  let companyCode = valueForm.companyCode || ''
  let assetOptions = state.options.assets.data.filter(a => a.companyCode === companyCode)

  const orderOptions = state.options.orders.data.map(o => ({
    ...o,
    text: o.text.removeLeadingZero(),
  }))

  const menus = state.pr.menus || []
  let category = {}
  let subCategory = {}
  if (valueForm) {
    if (valueForm.menuCategory) {
      category = getCategory(menus)(valueForm.menuCategory)
    }

    if (valueForm.menuSubCategory && category.subCategories) {
      subCategory = getSubCategory(category.subCategories)(valueForm.menuSubCategory)
    }
  }

  const attachmentTypes = state.pr.attachmentTypes
  const attachmentType = attachmentTypes.find(a => a.code === subCategory.attachmentType)

  return ({
    accountAssignmentOptions: state.options.accountAssignments.data,
    assetOptions,
    attachmentType,
    budgetTypeOptions: state.options.budgetTypes.data,
    companyOptions: state.options.companies.data,
    costCenterOptions: state.options.costCenters.data,
    currencyOptions: state.options.currencies.data,
    glAccountOptions: state.options.glAccounts.data,
    goaItemOptions,
    goaOptions,
    materialGroupOptions: state.options.materialGroups.data,
    memberOptions,
    orderOptions,
    prCategoryOptions: state.options.prCategories.data,
    prTypeOptions: state.options.prTypes.data,
    profitCenterOptions: state.options.profitCenters.data,
    purchasingGroupOptions: state.options.purchasingGroups.data,
    purchasingOrgOptions: state.options.purchasingOrgs.data,
    plantOptions: state.options.plants.data,
    storageLocationOptions: state.options.storageLocations.data,
    unitOptions: state.options.units.data,
    vendorOptions: state.options.vendors.data,
    projectOptions,
    specialApprovalOptions,
    wbsOptions: state.options.wbsElements.data,
    initialValues: {
      ...valueForm,
    },
    approvers: state.pr.approvers,
    approverLoading: state.pr.approverLoading,
    valueForm
  })
}

const mapDispatchToProps = {
  createPr,
  getWorkflowApprover,
  validateBudget,
  showConfirmModal,
  showModal,
  appLoading
}

const enhance = compose(
  // withState('showReqInfo', 'setShowReqInfo', true),
  withState('showGeneralInfo', 'setShowGeneralInfo', true),
  withState('showItems', 'setShowItems', true),
  withState('showBudgets', 'setShowBudgets', true),
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formCreatePR',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  lifecycle({
    componentDidMount() {
      this.props.getWorkflowApprover(this.props.valueForm)
    },
  })
)

export default enhance(Summary)
